import Carousel from '../../../../../common/widgets/Carousel';
import { ContestModel } from '../../../models/Contest';
import { ContestBanner } from './ContestBanner';

export const ContestsBanner = (props: { contests: ContestModel[] }) => {
  const { contests } = props;

  if (!contests?.length) return null;

  return (
    <div
      className={`edn-carousel edn-carousel-arrows no-arrows-tablet edn-carousel-dots contest-carousel${
        contests.length > 1 ? ' contest-carousel--with-pagination' : ''
      } mb-30`}
    >
      <Carousel
        dots={false}
        infinite={contests.length > 1} // if infinite is true and the carousel has only one item, it shows the item multiple times
        speed={500}
        slidesToShow={1}
        slidesToScroll={1}
        arrows={contests.length > 1}
        loading={false}
        adaptiveHeight
        responsive={[
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              dots: contests.length > 1,
            },
          },
        ]}
      >
        {contests.map(e => (
          <ContestBanner key={e.contestId} contest={e} />
        ))}
      </Carousel>
    </div>
  );
};
